import { LanguageCode } from "../../types";

/**
 * 獲取語言的i18n鍵
 * @param languageCode 語言代碼
 * @returns 語言的i18n鍵
 */
export const getLanguageI18nKey = (languageCode: string): string => {
    const keyMap: Record<string, string> = {
        "zh-TW": "APPWIDGET.LANGUAGE_ZH_TW",
        taiwanese: "APPWIDGET.LANGUAGE_TAIWANESE",
        "zh-CN": "APPWIDGET.LANGUAGE_ZH_CN",
        "zh-HK": "APPWIDGET.LANGUAGE_ZH_HK",
        "en-US": "APPWIDGET.LANGUAGE_EN_US",
        "en-GB": "APPWIDGET.LANGUAGE_EN_GB",
        "ja-JP": "APPWIDGET.LANGUAGE_JA_JP",
        "ko-KR": "APPWIDGET.LANGUAGE_KO_KR",
        "fr-FR": "APPWIDGET.LANGUAGE_FR_FR",
        "es-ES": "APPWIDGET.LANGUAGE_ES_ES",
        "ca-ES": "APPWIDGET.LANGUAGE_CA_ES",
        "vi-VN": "APPWIDGET.LANGUAGE_VI_VN",
        "th-TH": "APPWIDGET.LANGUAGE_TH_TH",
        "id-ID": "APPWIDGET.LANGUAGE_ID_ID",
        "ro-RO": "APPWIDGET.LANGUAGE_RO_RO",
        "ru-RU": "APPWIDGET.LANGUAGE_RU_RU",
    };
    return keyMap[languageCode] || languageCode;
};

/**
 * 獲取語言的顯示名稱
 * @param language 語言代碼
 * @returns 語言的顯示名稱
 */
export const getLanguageLabel = (language: LanguageCode) => {
    return getLanguageI18nKey(language)
        .replace(/\s*[（(][^)）]*[)）]\s*$/g, "")
        .trim();
};
